firebird.directive('featureFlags', [
    'templateCache',
    'helperService',
    function (templateCache, helperService) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate(helperService.getRedesignPathPrefix() + 'modals/feature-flags.html')
        };
    }
]);
